import React from 'react';
const TickSkill = (props) => (
    <div className="skill">
        <i className="fa fa-check-circle-o" aria-hidden="true"></i>
        <span>{props.name}</span>
    </div>
);

export default TickSkill;


// WEBPACK FOOTER //
// ./src/components/skills/Charts/tickSkill.js